import { useAppSelector } from 'features/app/hooks';
import { UserSipHeaderTag } from 'features/user/enums';
import { agentNumberSelector } from 'features/user/store';

export const useUserSipHeader = () => {
  const agentNumber = useAppSelector(agentNumberSelector);
  const USER_INTERFACE_INTERPRETER_MODE_VALUE = '3';

  const getUserSipHeader = (): Record<UserSipHeaderTag, string> => {
    return {
      [UserSipHeaderTag.INTERFACE_GROUP_TAG]:
        USER_INTERFACE_INTERPRETER_MODE_VALUE,
      [UserSipHeaderTag.ALTERNATE_NAME]: `Interpreter ${agentNumber}`,
    };
  };

  return { getUserSipHeader };
};
